import { LoggyApis } from '../../apis';

export const pushLoggyEvent = (data) => {
  const callApi = async () => {
    try {
      const res = await LoggyApis.pushLoggyEvent(data);

      if (res.status === 500) {
        throw res;
      }

      const res_data = await res.json();

      if (!res.ok) {
        throw res_data;
      }
    } catch (err) {
      // console.log(payload);
    }
  };

  return Promise.resolve(callApi());
};
